package com.example.positionahead.model

data class SymbolPerformance(
    val return1MonthPercent: Double? = null,
    val returnYtdPercent: Double? = null,
)
